import React from 'react';
import ReactDOM from 'react-dom/client';
import './Styles.css';
import App from './App';

// set scroll restoration before rendering
if ('scrollRestoration' in window.history) {
  window.history.scrollRestoration = 'manual';
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
